import { IReduxStore }                                  from 'Redux/Store/IReduxStore';
import { filterObjectStore, queryFilter, IFilterProps } from 'Redux/Query';
import { FileReference }                                from 'Domain/Model/FileReference/FileReference';

export const getFileReferences = (state: IReduxStore, filter: null | IFilterProps<FileReference> = null) => {
  if (filter === null) {
    filter = queryFilter({ sorting: { by: 'origin', order: 'ASC' } }) as IFilterProps<FileReference>;
  }

  return filterObjectStore(state.fileReference.fileReference.entries, filter);
};
